import { render, staticRenderFns } from "./MedicationUpdateModal.vue?vue&type=template&id=a34123c4&scoped=true&"
import script from "./MedicationUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./MedicationUpdateModal.vue?vue&type=script&lang=ts&"
import style0 from "./MedicationUpdateModal.vue?vue&type=style&index=0&id=a34123c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34123c4",
  null
  
)

export default component.exports